import React from 'react';
import Link from './Link';
import {getBrandName} from './Brand';


const SignupBox = ({role, href, onClick}) => {
  let header = `Your ${getBrandName()} membership awaits.`;
  if (role) header = `Learn everything you need to ace your ${role} interviews.`;

  return (
    <div className="my-12 rounded-xl bg-gradient-to-r from-indigo-700 to-purple-700 shadow-xl">
      <div className="mx-auto max-w-2xl py-12 px-8 md:px-4 text-center sm:py-16 sm:px-6 lg:px-8">
        <h3 className="text-2xl md:text-3xl font-bold tracking-tight text-white sm:text-4xl">
          <span className="block">{header}</span>
        </h3>
        <p className="mt-4 text-lg leading-6 text-indigo-200">
          {`${getBrandName()} is the fastest-growing tech interview prep platform. Get free interview
          guides, insider tips, and courses.`}
        </p>
        <Link
          href={href}
          className="mt-8 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-indigo-600 hover:bg-indigo-50 sm:w-auto"
          onClick={onClick}
        >
          Create your free account
        </Link>
      </div>
    </div>
  );
};

export default SignupBox;
